import { MapSelectInteraction3 } from "@omnia/shared/map/selectInteraction3";
import { IMap } from "@omnia/types";

export class MapSelectInteraction extends MapSelectInteraction3 {

    constructor(map: IMap, canSelectFeaturePredicate?: (feature: any) => boolean) {
        super(map.getMap(), canSelectFeaturePredicate);
    }

}
